module.exports = __webpack_public_path__ + "img/Close.8b7e35d9.svg";